var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwichBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6596 13.836H30.9963V23.8227H27.6596M36.8296 13.836H40.1663V23.8227H36.8296M16.8329 4.66602L8.50293 12.996V43.0027H18.4896V51.3327L26.8429 43.0027H33.4929L48.4963 27.9994V4.66602M45.1596 26.3427L38.5096 32.9927H31.8363L26.0029 38.826V32.9927H18.4896V8.00268H45.1596V26.3427Z",
    fill: "#9021FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwichBig);
export default __webpack_public_path__ + "static/media/twichBig.dbdf11fbec3b22fda25d6a4ed414e892.svg";
export { ForwardRef as ReactComponent };